export const LANGUAGE_KEY = 'app_language';
